import React from 'react'
import { FlightDropdownOption } from 'components/Flights/types'

import RadioGroup from 'components/Luxkit/RadioButton/RadioGroup'
import DropdownOption from 'components/Flights/FlightSorting/FlightDropdownToggle/FlightDropdownOption'
import Modal from 'components/Luxkit/Modal/Modal'

interface Props {
  open: boolean;
  options: Array<FlightDropdownOption>;
  selectedOption: FlightDropdownOption;
  title: string;
  onClose: () => void;
  onOptionChange: (option: FlightDropdownOption) => void;
  onApply: () => void;
}

function FareDropdownMobileMenu(props: Props) {
  const {
    open,
    options,
    selectedOption,
    title,
    onClose,
    onOptionChange,
    onApply,
  } = props

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title={title}
      onPrimaryActionClick={onApply}
      primaryActionText="Apply"
    >
      <RadioGroup>
        {options.map(option => (
          <DropdownOption
            key={option.value}
            checked={selectedOption === option}
            option={option}
            name={title}
            onChange={onOptionChange}
          />
        ))}
      </RadioGroup>
    </Modal>
  )
}

export default FareDropdownMobileMenu
